import { appIdentifier } from '@penji/frontend/installation';

type BrandId = 'penji' | 'reach';

const getBrandId = (): BrandId => {
    if (appIdentifier.startsWith('com.penjiapp.penji')) {
        return 'penji';
    }

    if (appIdentifier.startsWith('com.penjiapp.admin')) {
        return 'penji';
    }

    if (appIdentifier.startsWith('com.penjiapp.reach')) {
        return 'reach';
    }

    throw new Error('not_implemented');
};

const brandId = getBrandId();

export const Brand = {
    id: brandId,
    select<T>(spec: Record<BrandId, T>): T {
        return spec[brandId];
    },
};
